import { PRIVACY_POLICY_BANNER_HEADER_MODULE_ID } from 'root/src/shared/descriptions/modules/moduleIds'

export default {
	[PRIVACY_POLICY_BANNER_HEADER_MODULE_ID]: {
		moduleType: 'bannerHeader',
		bannerImageText: 'Privacy Policy',
		bannerSubText: '',
	},
}
